import React, { Component } from 'react'
import Link from '../../../front/components/shared/sn-link'
import { i18n } from '../../../validator'
import classnames from 'classnames'

const logoSnect = '/images/sn-logo-new.svg'

@i18n()
class LandingHeader extends Component {

    render() {
        const {
            t,
            className,
        } = this.props

        return (
            <div
                className={classnames({
                    'landing-header my-3 w-100 bg-transparent position-fixed top-0 text-center': true,
                    [className]: !!className,
                })}
            >
                <div className="d-flex justify-content-between mx-auto wide-layout">
                    <div className="pl-3 pl-lg-5 d-flex">
                        <Link
                            to="/"
                            className="mr-1 mr-sm-4 logo--full logo"
                        >
                            <img src={logoSnect} alt="logo" />
                        </Link>
                    </div>
                    <div className="d-flex pr-3 pr-lg-5">
                        <Link
                            className="btn btn-circle font-weight-bold hover-underline"
                            to="/signup"
                        >
                            {t('register')}
                        </Link>

                        <Link
                            className="btn btn-outline-color-brand btn-circle position-relative landing-header__login-button"
                            to="/login"
                        >
                            {t('login')}
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default LandingHeader
